import React from "react";

import "../Star.css";

const Star10 = () => {
  return (
    <span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star checked"></span>
    </span>
  );
};

export default Star10;
